/**
 * @generated SignedSource<<8ccdcfb6b4e550249986143c9520bc8e>>
 * @relayHash ec572469dc7cb396c2c3ddb94f82a68e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bf5d569536e3a040af0c422a9b3c4e844ecc1d9c3da79e3cd26f685259e5a950

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GraphIntegrationDirectoryItemType = "ACTION" | "CUSTOM_SKILL" | "FORGE_TOOL" | "MCP_SERVER" | "MCP_TOOL" | "PLATFORM_SKILL" | "SKILL" | "%future added value";
export type GraphIntegrationSurface = "AUTOMATION" | "CSM" | "POLLINATOR" | "ROVO" | "ROVO_AGENTS" | "ROVO_CLAW" | "STUDIO" | "%future added value";
export type browseSkills_Query$variables = {
  after?: string | null;
  cloudId: string;
  dimensionIds?: ReadonlyArray<string> | null;
  first?: number | null;
  relevantFor?: ReadonlyArray<GraphIntegrationDirectoryItemType> | null;
  searchKeyword?: string | null;
  surface?: GraphIntegrationSurface | null;
};
export type browseSkills_Query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"browseSkills_AtlassianRovoSkills_BrowseSkillsLegacy_preloadedRef">;
};
export type browseSkills_Query = {
  response: browseSkills_Query$data;
  variables: browseSkills_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dimensionIds"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": [
    "SKILL"
  ],
  "kind": "LocalArgument",
  "name": "relevantFor"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchKeyword"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "surface"
},
v7 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "dimensionIds",
    "variableName": "dimensionIds"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "relevantFor",
    "variableName": "relevantFor"
  },
  {
    "kind": "Variable",
    "name": "searchKeyword",
    "variableName": "searchKeyword"
  },
  {
    "kind": "Variable",
    "name": "surface",
    "variableName": "surface"
  }
],
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v9 = {
  "kind": "ScalarField",
  "name": "id"
},
v10 = {
  "kind": "ScalarField",
  "name": "iconUrl"
},
v11 = [
  (v9/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "browseSkills_Query",
    "selections": [
      {
        "args": (v7/*: any*/),
        "kind": "FragmentSpread",
        "name": "browseSkills_AtlassianRovoSkills_BrowseSkillsLegacy_preloadedRef"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "browseSkills_Query",
    "selections": [
      {
        "args": (v7/*: any*/),
        "concreteType": "GraphIntegrationDirectoryItemConnection",
        "kind": "LinkedField",
        "name": "graphIntegration_componentDirectoryItems",
        "plural": false,
        "selections": [
          {
            "concreteType": "GraphIntegrationDirectoryItemEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v9/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "slashCommand"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "description"
                      },
                      (v10/*: any*/),
                      {
                        "concreteType": "GraphIntegrationDirectoryFilterDimension",
                        "kind": "LinkedField",
                        "name": "integrationKey",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "displayName"
                          },
                          (v10/*: any*/),
                          (v9/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "color"
                      }
                    ],
                    "type": "GraphIntegrationSkillDirectoryItem"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "GraphIntegrationActionDirectoryItem"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "GraphIntegrationMcpServer"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "GraphIntegrationMcpTool"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "GraphIntegrationSkillItem"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              },
              {
                "kind": "ScalarField",
                "name": "hasPreviousPage"
              },
              {
                "kind": "ScalarField",
                "name": "startCursor"
              },
              {
                "kind": "ScalarField",
                "name": "endCursor"
              }
            ]
          },
          {
            "concreteType": "QueryError",
            "kind": "LinkedField",
            "name": "error",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              },
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "statusCode"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "errorType"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "args": (v7/*: any*/),
        "filters": [
          "dimensionIds",
          "searchKeyword",
          "relevantFor",
          "cloudId",
          "surface"
        ],
        "handle": "connection",
        "key": "browseSkills_graphIntegration_componentDirectoryItems",
        "kind": "LinkedHandle",
        "name": "graphIntegration_componentDirectoryItems"
      }
    ]
  },
  "params": {
    "id": "bf5d569536e3a040af0c422a9b3c4e844ecc1d9c3da79e3cd26f685259e5a950",
    "metadata": {},
    "name": "browseSkills_Query",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9bb9c55d0593497c8865eb24fcc4a2eb";

export default node;
